export default function NotFound() {
  return "Parece que esa página no existe en nuestro servidor, intenta de nuevo...";
}
